export const bankReconciliationDynamicMessagesEs = {
  // Bank Reconciliation
  bankreconciliation_banktransactionid_required:
    "Se requiere el ID de la transacción bancaria",
  bankreconciliation_either_invoicepayment_invices_reqired:
    "Se requiere una factura o facturas de pago",
  bankreconciliation_either_invoicepayment_invoices_reqired:
    "Se requiere una factura o facturas de pago",
  bankreconciliation_banktransaction_notfound:
    "Transacción bancaria no encontrada",
  bankreconciliation_paymenttransaction_notfound:
    "Transacción de pago no encontrada",
  bankreconciliation_transactionTypeMismatch:
    "Incompatibilidad en el tipo de transacción",
  bankreconciliation_transactionCurrencyMismatch:
    "La moneda de la transacción de pago ({{0}}) y la moneda de la transacción bancaria ({{1}}) deben coincidir.",
  bankreconciliation_transactionAmountMismatch:
    "El monto de la transacción de pago ({{0}}) y el monto de la transacción bancaria ({{1}}) deben coincidir.",
  bankreconciliation_invoice_deleted: "La factura ha sido eliminada",
  bankreconciliation_invoice_status_processedorreviewed:
    "El estado de la factura es procesada o revisada",
  bankreconciliation_invoice_transactionTypeMismatch:
    "Incompatibilidad en el tipo de transacción de la factura",
  bankreconciliation_invoice_paymentStatusMissMatch:
    "Incompatibilidad en el estado de pago de la factura",
  bankreconciliation_invoice_approvalrequired:
    "Se requiere la aprobación de la factura",
  bankreconciliation_invoice_customercompanyidrequired:
    "Se requiere el ID de la empresa cliente de la factura",
  bankreconciliation_invoice_customercompanyidshouldsame:
    "El ID de la empresa cliente de la factura debe ser el mismo",
  bankreconciliation_invoice_vendorcompanyidrequired:
    "Se requiere el ID de la empresa proveedora de la factura",
  bankreconciliation_invoice_vendorcompanyidshouldsame:
    "El ID de la empresa proveedora de la factura debe ser el mismo",
};
